export const AVERAGE_USER_XVS_VAULT_STAKE_TOKENS = 4000;
